import { Box, Stack, Typography } from '@mui/material';
import { FC } from 'react';
import { NumberBox } from './NumberBox';
import { baseCardButtonStyling, baseCardStyling } from './styles';
import IncrementButton from './IncrementButton';

type SpeedProps = {
  speed: number;
  handleSpeedChange: (value: number) => void;
  handleStaticSpeedChange: (value: number) => void;
};

export const Speed: FC<SpeedProps> = ({
  speed,
  handleSpeedChange,
  handleStaticSpeedChange,
}) => {
  return (
    <Box
      sx={(theme) => ({
        backgroundColor: '#202123',
        height: '100%',
        padding: 2,
      })}
    >
      <Stack
        direction="column"
        spacing={2}
        className="w-full"
        justifyContent="center"
        alignContent="center"
        sx={(theme) => ({ height: '100%' })}
      >
        <Box>
          <Stack
            direction="column"
            className="w-full"
            justifyContent="center"
            alignItems="center"
          >
            <Typography
              variant="h5"
              sx={(theme) => ({ color: 'white', fontWeight: 'bold' })}
            >
              SPEED
            </Typography>
            <Typography
              variant="h5"
              sx={(theme) => ({ color: 'yellow', fontWeight: 'bold' })}
            >
              km/h
            </Typography>
          </Stack>
        </Box>
        <Box
          display="flex"
          justifyContent="center"
          alignItems="center"
          sx={(theme) => ({ height: '50px', marginTop: '0px !important' })}
        >
          {' '}
          <Typography
            sx={(theme) => ({
              color: 'white',
              fontSize: '4rem',
              fontWeight: 'bold',
            })}
          >
            {speed.toFixed(1)}
          </Typography>
        </Box>
        <NumberBox number={10} onClick={handleStaticSpeedChange} />
        <NumberBox number={8} onClick={handleStaticSpeedChange} />
        <NumberBox number={6} onClick={handleStaticSpeedChange} />
        <NumberBox number={4} onClick={handleStaticSpeedChange} />
        <Box>
          <Stack
            direction="column"
            spacing={2}
            className="w-full"
            sx={(theme) => ({ height: '100px' })}
            display="flex"
            justifyContent="center"
            alignItems="center"
          >
            <IncrementButton
              text={'+'}
              onClick={() => handleSpeedChange(0.1)}
            />
            <IncrementButton
              text={'-'}
              onClick={() => handleSpeedChange(-0.1)}
            />
          </Stack>
        </Box>
      </Stack>
    </Box>
  );
};
